import { render, staticRenderFns } from "./CMTermsConditions.vue?vue&type=template&id=78ec8934&"
import script from "./CMTermsConditions.vue?vue&type=script&lang=js&"
export * from "./CMTermsConditions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentVOP/build/VOPWebApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78ec8934')) {
      api.createRecord('78ec8934', component.options)
    } else {
      api.reload('78ec8934', component.options)
    }
    module.hot.accept("./CMTermsConditions.vue?vue&type=template&id=78ec8934&", function () {
      api.rerender('78ec8934', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/popups/CMTermsConditions.vue"
export default component.exports